import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from './logo.png';

const AppHeader = () => {
  return (
    <div className="menu-bar">
      <div className="menu-bar__primary-navigation">
        <Link to="/">
          <img src={logoImage} alt="TIRC logo" height="12" width="auto" />
        </Link>
      </div>
      <div className="menu-bar__secondary-navigation"></div>
      <div className="menu-bar__tertiary">
        <span>Technical Information Requirement Catalogue</span>
      </div>
    </div>
  );
};

export default AppHeader;
